import $ from 'jquery';
// import mpro from './mpro.init';

import { getCssVar } from '../../util/generic';
import { defaultOptions as tippyDefaultOptions } from '../../shop/modules/tippy-util';

/**
 * @param {JQuery|Element} container
 */
mpro.initFilterSelect2 = async (container) => {

	/** @type {JQuery} */
	// @ts-ignore
	const $container = (container instanceof $) ? container : $(container);

	const $selects = $container.find('select:not(.native)');

	if ($selects.length > 0) {

		// Load select2 lib
		await import('./mpro.select2');

		// Init select 2
		$selects.select2();
	}
};

/**
 * @param {JQuery|Element} sliderContainer
 */
mpro.initFilterSlider = async (sliderContainer) => {

	/** @type {JQuery} */
	// @ts-ignore
	const jqSliderContainer = (sliderContainer instanceof $) ? sliderContainer : $(sliderContainer);

	let jqSliderDummy = jqSliderContainer.find('div.filter-slider-dummy');
	let jqSlider;

	if (jqSliderDummy.length > 0) {
		jqSlider = jqSliderContainer.find('div.slider-wrap').not(jqSliderDummy);
	}
	// Allow re-initialization
	else {
		jqSliderDummy = jqSliderContainer.find('div.slider-wrap');
		jqSlider = $('<div class="slider-wrap sdf" style="display: none;"></div>');
		jqSlider.insertBefore(jqSliderDummy);
	}

	// No need to load anything
	if (!jqSlider.length) {
		return;
	}

	// Lazy load slider plugins
	const [
		{ 'default': noUiSlider },
		{ 'default': wNumb },
	] = await Promise.all([
		import('nouislider'),
		import('wnumb'),
	]);

	const sliderElement = jqSlider[0];
	const sData = jqSliderContainer.data();
	// const jqSubmit = jqSliderContainer.find('.slider-submit-button');
	const jqMin = jqSliderContainer.find('.slider-min-handle');
	const jqMax = jqSliderContainer.find('.slider-max-handle');
	const minVal = sData.sliderRange ? Number(sData.sliderRange[0]) : 0;
	const maxVal = sData.sliderRange ? Number(sData.sliderRange[1]) : 0;

	// var formatter = wNumb(sData.sliderFormatter);
	const formatter = wNumb({
		decimals: 0,
		mark: '',
		thousand: '',
		suffix: '',
		prefix: '',
	});

	// Ignore all clicks propagation up from the slider container (for ajax-navigation to not register double clicks)
	jqSlider.on('click', false);

	if (minVal === maxVal) {
		return;
	}

	/* Remove the dummy pre-rendered slider */
	jqSliderDummy.remove();
	jqSlider.show(0);

	const slider = noUiSlider.create(sliderElement, {
		connect: true,
		snap: false,
		behaviour: 'tap-drag',
		step: 1,
		margin: 1,
		range: {
			min: minVal,
			max: maxVal,
		},
		format: formatter,
		/* tooltips: [formatter, formatter], */
		start: sData.sliderSelection,
	});

	jqSlider.on('destroy', () => {
		slider.destroy();
	});

	const onChangeHandler = function(i) {
		return /** @this {HTMLInputElement} @param {JQuery.TriggeredEvent} e */ function(e, evData) {
			// Prevent infinite loop
			if (evData && evData.from === 'slider-native') {
				return;
			}

			const sVal = slider.get();
			const otherIndex = Math.abs(i - 1);

			// Overwrite slider vals
			sVal[i] = formatter.from(this.value) || (i == 0 ? minVal : maxVal);
			sVal[otherIndex] = formatter.from(sVal[otherIndex]) || (i == 0 ? maxVal : minVal);

			// Only send the changed value
			sVal[otherIndex] = null;

			// Set the slider new val
			slider.set(sVal, false, false);
		};
	};
	jqMin.on('change', onChangeHandler(0));
	jqMax.on('change', onChangeHandler(1));
	jqMin.add(jqMax).on('keyup', (e) => {
		const key = window.event ? e.keyCode : e.which;
		if (key === 13) {
			$(sliderElement).trigger('set');
		}
	}).on('blur', (e) => {
		$(sliderElement).trigger('set');
	});

	slider.on('update', (values, handle, values_raw, tap, positions, slider) => {
		let value = values_raw[handle];
		const otherVal = values_raw[Math.abs(handle - 1)];

		if (handle) {
			if (value < otherVal) {
				value = otherVal;
			}
		}
		else {
			if (value > otherVal) {
				value = otherVal;
			}
		}
		if (value < minVal) {
			value = minVal;
		}
		if (value > maxVal) {
			value = maxVal;
		}

		const fixedFloat = value.toFixed(2);
		const intVal = parseInt(fixedFloat, 10);
		const inputVal = intVal;
		const fmtVal = ((handle && (inputVal !== maxVal)) || (!handle && (inputVal !== minVal))) ? formatter.to(inputVal) : '';

		if (handle) {
			jqMax.val(fmtVal).trigger('change', { from: 'slider-native' });
		}
		else {
			jqMin.val(fmtVal).trigger('change', { from: 'slider-native' });
		}
	});

	slider.on('set', (values) => {
		$(sliderElement).trigger('set');
	});
};

/**
 * @param {JQuery} container
 */
mpro.initTippyFacets = async (container) => {

	const $container = (container instanceof $) ? container : $(container);

	// Open page top facets in tippy
	const $facetsContainer = $container.find('.facets-page-top form');

	if ($facetsContainer.length > 0) {

		const facetsPageTopInstances = [];

		// Init top facets
		const $facetsTrigger = $facetsContainer.find('.facet__title');
		if ($facetsTrigger.length > 0) {

			// Load tippy.js lib
			const { 'default': tippy, createSingleton } = await import('tippy.js');

			$facetsTrigger.each(function() {
				const $menu = $(this);
				const $content = $menu.next('.facet__content');
				const $contentClone = $content.clone();
				// Keep the original content reference in order to remove it on filter submission
				$contentClone.data('original', $content);

				// Init sliders in cloned content
				$contentClone.find('.filter-slider').each(function() {
					mpro.initFilterSlider(this);
				});

				// @ts-ignore
				// facetsPageTopInstances.push(tippy($menu[0], {
				tippy($menu[0], {

					...tippyDefaultOptions,

					appendTo: $menu.parent()[0],
					content: $contentClone[0],
					placement: 'bottom-start',
					offset: [0, 10],
					onHide: (instance) => {
						const original = $(instance.props.content).data('original');
						if (original.length) {
							original.replaceWith($(instance.props.content).clone(true));
						}

						$(instance.reference).removeClass('active');
					},
					onShown: (instance) => {
						$(instance.reference).addClass('active');
					},
					popperOptions: {
						modifiers: [
							...tippyDefaultOptions.popperOptions.modifiers,
							{ name: 'flip', enabled: false },
							{
								name: 'applyZIndex',
								enabled: true,
								phase: 'beforeWrite',
								fn: (data) => {
									data.state.styles.popper.zIndex = getCssVar('zindex-dropdown', '1000');
								},
							},
							{
								name: 'preventOverflow',
								enabled: true,
								options: {
									rootBoundary: $facetsContainer[0],
									padding: 0,
								},
							},
						],
					},
					trigger: 'click',
				});
				// }));
			});

			// Link all main menus
			// createSingleton(facetsPageTopInstances, { trigger: 'click', overrides: [...Object.keys(tippyDefaultOptions), 'content', 'placement'] });
		}
	}
};

/**
 * @param {JQuery} container
 */
mpro.handleFacetsSubmit = function(container) {

	const $facetContainer = (container instanceof $) ? container : $(container);

	const buildFacetSummary = ($facet) => {
		const $menu = $facet.closest('.mm-menu');

		const facetSummary = $.map($facet.find('input:checkbox, input:radio'), (input) => {
			const $input = $(input);
			if ($input.is(':checked')) {
				return $.trim($input.closest('.facet__option').clone().find('.mm-counter').remove().end().text());
			}

			return '';
		}).filter(String).join(', ');

		const $btn = $menu.find('.mm-btn[href=\'#' + $facet.prop('id') + '\']');

		if ($btn.find('.facet__title-selected-values').length) {
			$btn.find('.facet__title-selected-values').html(facetSummary);
		}
		else {
			$btn.append('<div class="facet__title-selected-values">' + facetSummary + '</div>');
		}
	};

	const doSubmit = (e) => {

		const $currentTarget = $(e.currentTarget);
		const $target = $(e.target);
		const isBatchSelection = $target.closest('.facet__options--batch-selection').length > 0;
		const facetContent = $target.closest('.facet__content');

		// Prevent submit on individual options is batch selection is active
		if (isBatchSelection) {
			if (facetContent.closest('.mm-menu').length) {
				buildFacetSummary(facetContent);
			}

			return;
		}

		$facetContainer.find('input, select').each(function() {
			if ($(this).closest('.tippy-content').length) {
				const original = $(this).closest('.tippy-content').find('.facet__content').data('original');
				if (original.length) {
					original.remove();
				}
			}
		});

		const $facetContainerForm = $facetContainer.closest('form');
		const filterParams = $facetContainer.find('input, select').serializeArray().filter((v) => {
			return v.value;
		}).reduce((all, v) => {
			all[v.name] = all[v.name] ?? []; all[v.name].push(v.value); return all;
		}, {});
		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);

		const fParams = [];
		const wParams = [];
		let url_action = '';

		for (const param_name in filterParams) {
			if (param_name.startsWith('f[')) {
				fParams.push(filterParams[param_name]);
				delete filterParams[param_name];
			}
			else if (param_name.startsWith('w[')) {
				wParams.push(filterParams[param_name]);
				delete filterParams[param_name];
			}
			else {
				filterParams[param_name] = filterParams[param_name].join(',');
			}
		}
		if (fParams.length > 0) {
			filterParams['f'] = fParams.join(',');
		}
		if (wParams.length > 0) {
			filterParams['w'] = wParams.join(',');
		}

		// Keep the category from search params
		if ( !('c' in filterParams) && (urlParams.get('c') !== null) ) {
			filterParams['c'] = urlParams.get('c');
		}

		// if ('c' in filterParams) {
		// 	if (typeof $facetContainer.data('rootUrl') !== 'undefined') {
		// 		url_action = $facetContainer.data('rootUrl');
		// 	}
		// 	else {
		// 		url_action = mpro.config.routes.catalog;
		// 	}
		// }
		// else {
		// 	url_action = $facetContainer.data('action');
		// }

		if (typeof $facetContainer.data('rootUrl') !== 'undefined') {
			url_action = $facetContainer.data('rootUrl');
		}
		else {
			if (
				'c' in filterParams &&
				typeof $facetContainer.data('pageType') !== 'undefined' &&
				$facetContainer.data('pageType') === 'category' &&
				typeof $facetContainer.data('categoryId') !== 'undefined' &&
				$facetContainer.data('categoryId') > 0 &&
				parseInt(filterParams['c']) !== $facetContainer.data('categoryId')
			) {
				url_action = mpro.config.routes.catalog;
			}
			else {
				delete filterParams['c'];
				url_action = $facetContainer.data('action');
			}
		}

		// if (Object.keys(filterParams).length > 0) {
		mpro.setLocation(url_action + (Object.keys(filterParams).length > 0 ? '?' : '') + decodeURIComponent(jQuery.param(filterParams)));
		// }
	};

	if ($facetContainer.length > 0) {
		$facetContainer.on('click change set summary keyup focusin focusout', '.facet__option--radio, .facet__option--checkbox, .facet__option--tag, .facet__content--text, .facet__content--range-slider, .facet__content--select, .facet__batch-selection', (e) => {

			const dataLayerTrigger = (data) => {
				if (typeof window.dataLayerTrigger === 'function') {
					window.dataLayerTrigger.call(this, data);
				}
			}

			const $currentTarget = $(e.currentTarget);
			let $target = $(e.target);
			// The same behaviour as a link when a counter or color is clicked
			if (!$target.is('a') && $target.closest('a').length) {
				$target = $target.closest('a');
			}
			const $input = $(e.currentTarget).find('input').eq(0);
			const isBatchSelection = $target.closest('.facet__options--batch-selection').length > 0;

			// Prevent link redirect
			if (isBatchSelection) {
				if ($target.is('a')) {
					e.preventDefault();
				}
			}

			if (isBatchSelection) {
				if (e.type === 'summary') {
					buildFacetSummary($target.closest('.facet__content'));
				}
				if (e.type === 'click') {
					if ($currentTarget.is('.facet__option--radio')) {
						if ($target.is('a')) {
							if (!$input.prop('checked')) {
								$input.prop('checked', !$input.prop('checked'));
								doSubmit(e);
							}
						}
						else if ($target.is('input')) {
							doSubmit(e);
						}
					}
					else if ($currentTarget.is('.facet__option--checkbox')) {
						if ($target.is('a')) {
							$input.prop('checked', !$input.prop('checked'));
							doSubmit(e);
						}
						else if ($target.is('input')) {
							doSubmit(e);
						}
					}
					else if ($currentTarget.is('.facet__option--tag')) {
						if ($target.is('a')) {
							$input.val($target.is('.active') ? '' : $input.data('value'));
							doSubmit(e);
						}
					}
				}

				if ((e.type === 'change') && $currentTarget.is('.facet__content--select')) {
					if ($target.is('select')) {
						doSubmit(e);
					}
				}
			}
			else {
				if ($currentTarget.is('.facet__option--checkbox')) {
					if ($target.is('input') && (e.type === 'change')) {
						// doSubmit(e);
						if ($target.prop('checked')) {
							dataLayerTrigger({
								'event': 'product_filter',
								'value': $currentTarget.find('a').text(),
							});
						}
						mpro.setLocation($currentTarget.find('a')[0].href);
					}
					else if ($target.is('a') && (e.type === 'click')) {
						e.preventDefault();
						if (!$currentTarget.find('input').prop('checked')) {
							dataLayerTrigger({
								'event': 'product_filter',
								'value': $target.text(),
							});
						}
						$input.prop('checked', !$currentTarget.find('input').prop('checked'));
						// doSubmit(e);
						mpro.setLocation($target[0].href);
					}
				}

				if ($currentTarget.is('.facet__option--radio')) {
					if ($target.is('input') && (e.type === 'change')) {
						// doSubmit(e);
						dataLayerTrigger({
							'event': 'product_filter',
							'value': $currentTarget.find('a').text(),
						});
						mpro.setLocation($currentTarget.find('a')[0].href);
					}
					else if ($target.is('a') && (e.type === 'click')) {
						if ($input.is(':checked')) {
							return false;
						}
						e.preventDefault();
						dataLayerTrigger({
							'event': 'product_filter',
							'value': $target.text(),
						});
						$input.prop('checked', !$currentTarget.find('input').prop('checked'));
						// doSubmit(e);
						mpro.setLocation($target[0].href);
					}
				}
			}

			if ($currentTarget.is('.facet__content--text')) {
				if (e.type === 'focusin') {
					$input.data('oldValue', $input.val());
				}

				if ((e.type === 'focusout') && ($input.data('oldValue') !== $input.val())) {
					dataLayerTrigger({
						'event': 'product_filter',
						'value': $input.val(),
					});
					doSubmit(e);
				}

				if ((e.type === 'keyup') && ($input.data('oldValue') !== $input.val())) {
					const key = window.event ? e.keyCode : e.which;
					if (key === 13) {
						dataLayerTrigger({
							'event': 'product_filter',
							'value': $input.val(),
						});
						doSubmit(e);
					}
				}
			}

			if ($currentTarget.is('.facet__content--range-slider')) {
				if (e.type === 'set') {
					const {
						language,
						currency,
					} = mpro.config.env;
					const formatter = new Intl.NumberFormat(language.canonical_locale, {
						style: 'currency',
						currency: currency.iso_code,
					});

					let filterValue;
					const [from, to] = $currentTarget[0].querySelectorAll('input');
					if (from.value && to.value) {
						filterValue = formatter.format(from.value || 0) + ' - ' + formatter.format(to.value || 0);
					}
					else if (from.value) {
						filterValue = '> ' + formatter.format(from.value || 0);
					}
					else if (to.value) {
						filterValue = '< ' + formatter.format(to.value || 0);
					}
					dataLayerTrigger({
						'event': 'product_filter',
						'value': filterValue,
					});
					doSubmit(e);
				}
			}

			if ($currentTarget.is('.facet__batch-selection')) {
				if ($target.is('button')) {
					doSubmit(e);
				}
			}
		});
	}
};

export default mpro;
